<script>
  import RichTextEditor from '../RichTextEditor.svelte';
  import {sgettext} from '../../i18n.js';

  export let id = 'focusQuestionInput';
  export let label = sgettext('$$FOCUS_QUESTION$$');

  let defaultValue = {
    name: '',
    expired: false,
  };
  export let value = [{ ...defaultValue }];

  function addAnother() {
    value = [...value, { ...defaultValue }];
  }

  function handleKeyUp(event) {
    if (event.key === 'Enter') {
      addAnother();
    }
  }
  
  function remove(q){
    q.expired = true;
    value = [...value];
  }
</script>

<style>
  .link-add {
    display: flex;
  }

  .focus-question {
    margin-bottom: 5px;
    display: flex;
  }

  .editor {flex: 1;}
  .icon-remove {display: flex; align-items: center; padding: 5px; border: 1px solid #dddddd; border-left: none; cursor: pointer;}
  .icon-remove:hover {color: #dd5900;}

</style>

<label for={id}>{label}</label>

{#each value as q, i}
  {#if !q.expired}
  <div class="focus-question">
    <div class="editor">
      <RichTextEditor id={id + 'Editor' + i} bind:value={q.name} />
    </div>
    <div tabindex="0" class="icon-remove" on:click={() => remove(q)}>
      <i class="fa fa-times" aria-hidden="true" />
    </div>
  </div>
  {/if}
{/each}
<div class="link-add d-flex flex-row-reverse">
  <button tabindex="0" class="btn btn-outline-dark" on:click={addAnother} on:keyup={handleKeyUp} type="button">
    {value.filter(v => !v.expired).length > 0 ? sgettext('$$ADD_ANOTHER_FOCUS_QUESTION$$') : sgettext('$$ADD_FOCUS_QUESTION$$')}
  </button>
</div>
